//@import dependencies
import React from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
//@end

// @import hooks
// @end

// @INFO Import types
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../categorycardCommon.scss'

// @ADD Component types
interface ICategorycardCommonLayoutProps {
	aditionalClass: string,
	categorie: string,
  active?: boolean
}

const CategorycardCommonLayout: React.FC<ICategorycardCommonLayoutProps> = (props) => {
	const {aditionalClass, categorie, active} = props;
  const { t } = useTranslation()

  return(
    <div className={`Atomrecursocategorias ${aditionalClass} ${active ? 'active' : ''}`}>
		<span className={'categorie'}>{categorie}</span>
	</div>
  )
}

export default CategorycardCommonLayout
